<template>
  <b-columns
    is-multiline
    is-mobile
  >
    <b-column
      v-for="(option, idx) in options"
      :key=idx
      class="is-one-fifth-desktop is-half-mobile is-half-tablet"
    >
      <observation-option
        :name="option"
        :icon-name="categoryIcon"
        :selected="observationIsSelected(option)"
        @option-selected="select"
        @option-deselected="deselect"
      />
    </b-column>
  </b-columns>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ObservationOption from './ObservationOption'

export default {
  components: {
    ObservationOption
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    categoryIcon: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['observationIsSelected']),
  },
  methods: {
    ...mapActions({ select: 'selectObservation', deselect: 'deselectObservation' }),
  }
}
</script>
